// @ts-expect-error
import esriRequest from '@arcgis/core/request';
import { getRefreshDataHeader } from './getRefreshDataHeader';
import { buildCacheBustedRefreshUrl } from './layerRefreshUrl';


export async function fetchGeoJsonWithRefresh(
  layerUrl: string,
): Promise<unknown> {
  const refreshUrl = buildCacheBustedRefreshUrl(layerUrl);
  const response = await esriRequest(refreshUrl, {
    responseType: 'json',
    ...getRefreshDataHeader(true),
  });
  return response.data;
}
